import { render, staticRenderFns } from "./dynamic-question-renderer.vue?vue&type=template&id=4f3745ff&scoped=true"
import script from "./dynamic-question-renderer.vue?vue&type=script&lang=js"
export * from "./dynamic-question-renderer.vue?vue&type=script&lang=js"
import style0 from "./dynamic-question-renderer.vue?vue&type=style&index=0&id=4f3745ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3745ff",
  null
  
)

export default component.exports